module.exports = __webpack_public_path__ + "static/img/historical-data.b6bc452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/historical-data.png
// module id = 1oIF
// module chunks = 2